import { Card, Collapse, Stack } from '@mui/material';
import { Paths } from 'type-fest';

import {
  Typography,
  TextField,
  Switches,
  CardContent,
  CardHeader,
  InfoBox,
} from '@occc-app/design-system';
import { pluralize } from '@occc-app/lib/strings';

import {
  DEFAULT_SMS_BODY_LENGTH,
  SmsNotificationConfig,
} from '../../common/sms-notification-config.schema';
import { EngagementChannelConfigFormValues } from '../../common/engagement-channel-config.schema';

type SmsConfigurationProps = {
  values?: SmsNotificationConfig;
};

export const SmsConfiguration = ({ values }: SmsConfigurationProps) => {
  const smsBodyFieldLength = (values?.isEnabled && values?.body?.length) || 0;
  const smsBodyLengthLabel = pluralize(smsBodyFieldLength, 'character');

  return (
    <Card elevation={0}>
      <CardHeader
        sx={{ px: 0, py: 1 }}
        title={
          <Typography variant='h6' component='p' gutterBottom>
            Send out SMS
          </Typography>
        }
        action={
          <Switches
            name={'smsConfig.isEnabled' satisfies Paths<EngagementChannelConfigFormValues>}
            data={{}}
          />
        }
      />
      <Collapse in={values?.isEnabled} timeout='auto' unmountOnExit>
        <CardContent sx={{ px: 0 }}>
          <TextField
            label='Body'
            multiline
            name={'smsConfig.body' satisfies Paths<EngagementChannelConfigFormValues>}
          />
          <Typography textAlign='right' color='text.main' pt={0.5}>
            {smsBodyFieldLength}&nbsp;
            <Typography component='span' textAlign='right' color='text.secondary' pt={0.5}>
              {smsBodyLengthLabel}
            </Typography>
          </Typography>
          <Stack spacing={2} mt={1}>
            {smsBodyFieldLength > DEFAULT_SMS_BODY_LENGTH && (
              <InfoBox type='warning'>
                <Typography color='error.dark' variant='body2'>
                  Long messages may be split into multiple parts based on dynamic content.
                </Typography>
              </InfoBox>
            )}

            <InfoBox>
              <Typography color='primary.dark' variant='body2'>
                SMS message can have a deep link, but you need to add it in the text itself
              </Typography>
            </InfoBox>
          </Stack>
        </CardContent>
      </Collapse>
    </Card>
  );
};
